<nav class="color-primary">
    <ol *ngIf="breadcrumbs && breadcrumbs.length > 0">
        <li *ngFor="let breadcrumb of breadcrumbs">{{breadcrumb}}</li>
    </ol>
</nav>
